import { render, staticRenderFns } from "./operaplan2.vue?vue&type=template&id=4b1bf256&scoped=true&"
import script from "./operaplan2.vue?vue&type=script&lang=js&"
export * from "./operaplan2.vue?vue&type=script&lang=js&"
import style0 from "./operaplan2.vue?vue&type=style&index=0&id=4b1bf256&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1bf256",
  null
  
)

export default component.exports